import React, { Component } from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";

import team1 from "../assets/images/team/team-01.jpg";
import team2 from "../assets/images/team/team-02.jpg";
import team3 from "../assets/images/team/team-03.jpg";
import team6 from "../assets/images/team/team-06.jpg";
import team5 from "../assets/images/team/team-05.jpg";
import team12 from "../assets/images/team/team-12.jpg";

let TeamContent = [
  {
    url: "https://abogadoaescobarm.com/andres.JPG",
    title: "Andrés Escobar",
    designation: "Expero en Marketing y Abogado",
    socialNetwork: [
      {
        icon: <FaInstagram />,
        url: "https://www.instagram.com/aescobarem_/",
      },
      // {
      //   icon: <FaLinkedinIn />,
      //   url: "#",
      // },
      // {
      //   icon: <FaTwitter />,
      //   url: "#",
      // },
    ],
  },
  {
    url:"https://images.unsplash.com/photo-1515879218367-8466d910aaa4?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fGNvZGlnbyUyMGRlJTIwcHJvZ3JhbWFjaW9ufGVufDB8fDB8fHww",
    title: "José Hernández",
    designation: "Desarrollador Web Full-Stack",
    socialNetwork: [
      // {
      //   icon: <FaFacebookF />,
      //   url: "#",
      // },
      {
        icon: <FaLinkedinIn />,
        url: "https://www.linkedin.com/in/jos%C3%A9-armando-hern%C3%A1ndez-mendoza-a8874b223/",
      },
    ],
  },
  // {
  //   images: team3,
  //   title: "Al-Amin Bali",
  //   designation: "Sr. Graphic Designer",
  //   socialNetwork: [
  //     {
  //       icon: <FaFacebookF />,
  //       url: "#",
  //     },
  //     {
  //       icon: <FaLinkedinIn />,
  //       url: "#",
  //     },
  //     {
  //       icon: <FaTwitter />,
  //       url: "#",
  //     },
  //   ],
  // },
  // {
  //   images: team6,
  //   title: "Jone Due",
  //   designation: "Sr. Web Developer",
  //   socialNetwork: [
  //     {
  //       icon: <FaFacebookF />,
  //       url: "#",
  //     },
  //     {
  //       icon: <FaLinkedinIn />,
  //       url: "#",
  //     },
  //     {
  //       icon: <FaTwitter />,
  //       url: "#",
  //     },
  //   ],
  // },
  // {
  //   images: team5,
  //   title: "Fatima Asrafi",
  //   designation: "Front-end Engineer",
  //   socialNetwork: [
  //     {
  //       icon: <FaFacebookF />,
  //       url: "#",
  //     },
  //     {
  //       icon: <FaLinkedinIn />,
  //       url: "#",
  //     },
  //   ],
  // },
  // {
  //   images: team12,
  //   title: "Al-Amin Bali",
  //   designation: "Sr. Graphic Designer",
  //   socialNetwork: [
  //     {
  //       icon: <FaFacebookF />,
  //       url: "#",
  //     },
  //     {
  //       icon: <FaLinkedinIn />,
  //       url: "#",
  //     },
  //     {
  //       icon: <FaTwitter />,
  //       url: "#",
  //     },
  //   ],
  // },
];

class Team extends Component {
  render() {
    const { column } = this.props;
    return (
      <React.Fragment>
        {TeamContent.map((value, i) => (
          <div className={`${column}`} key={i}>
            <div className="team">
              <div className="thumbnail">
                <img src={value.images || value.url} alt="Blog Images" />
              </div>
              <div className="content">
                <h4 className="title">{value.title}</h4>
                <p className="designation">{value.designation}</p>
              </div>
              <ul className="social-icon">
                {value.socialNetwork.map((social, index) => (
                  <li key={index}>
                    <a href={`${social.url}`}>{social.icon}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </React.Fragment>
    );
  }
}
export default Team;
